var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webpay-header-landing',{attrs:{"loggedIn":_vm.loggedIn}}),_c('main',{staticClass:"container"},[_c('div',{staticClass:"dummy-band"}),_c('webpay-pages-affiliation')],1),_c('webpay-footer-landing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }